let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d7f2X")).then(() => parcelRequire('1VZsk'));